import React from 'react';
import ReactDOM from 'react-dom/client';
import Dashboard1 from './Dashboard1'
import EnterUsers from '../User/EnterUsers';
import { useState } from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { BrowserRouter as Router, Route, Routes, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import LoginForm from '../Login/LoginForm';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SidebarMenu from './MenuTree';
import SidebarmenuC from './CompanyMenuTree';
export default function AdminPanel() {


  /* const dummyData =[
        {
            "id":1,
            "users":"Gautam Kumar",
            "title":"Dam it",
            "author":"Rest Api",
            "isbn":"isbn34546",
            "description":"This is really good",
            "backCover":"file1.jpg"
        }
    ] */

  useEffect(() => {
    // Add a class to the body when this component is mounted
    document.body.classList.remove('login-bg'); // Remove class from <body> tag
    // Cleanup function to remove class when the component is unmounted
    return () => {
      document.body.classList.remove('login-bg'); // Remove the class on unmount
    };
  }, []); // Empty dependency array ensures this effect runs only once (on mount)


  const usersName = "Gautam Kumar"
  let content;
  let dashList;
  let hRef;
  /* switch(hRef){
   case "/dashboard":{
     content=<Dashboard1/>;
     dashList="Dashboard";
     break;
   }
   case "/insbook":{
     content=<InsertBooks/>;
     dashList="Insert Books";
     break;
     
   }
   case "/booklist":{
     content=<UserDashboard/>;
     dashList="Books Table";
     break;
     
   }
   case "/logout": {
     content="You are going to log out";
     dashList="Logout";
     break;
   }
   default:
     {`
       content="";
     dashList="No User";
     break;
     }

  } */

  const navigator = useNavigate();
  const handleLogout = (e) => {
    e.preventDefault();
    // Navigate to /page2 and pass the value
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('fullName');
    sessionStorage.removeItem('role');
    navigator("/login", { replace: true, state: { from: 'admin' }, forceRefresh: true });
    window.location.reload();
  };
  const [roleId, setRoleId] = useState(0);
  //roleId;
  // useNestedMenus.js or inside your component
  const buildMenuTree = (flatMenus) => {
    const menuMap = {};
    const roots = [];

    // Initialize menu map and add children array
    flatMenus.forEach(menu => {
      menu.children = [];
      menuMap[menu.menuId] = menu;
    });

    // Build tree
    flatMenus.forEach(menu => {
      if (menu.parentMenuId === 0) {
        roots.push(menu);
      } else {
        const parent = menuMap[menu.parentMenuId];
        if (parent) {
          parent.children.push(menu);
        }
      }
    });

    // Recursive sort function
    const sortMenus = (menus) => {
      menus.sort((a, b) => parseInt(a.menuOrder) - parseInt(b.menuOrder));
      menus.forEach(menu => {
        if (menu.children.length > 0) {
          sortMenus(menu.children);
        }
      });
    };

    // Sort the root menus and their children
    sortMenus(roots);

    return roots;
  };
  const [menusData, setMenusData] = useState([]);
  const [companyId,setCompanyId] = useState(null);
  //const srcImg="http://localhost:8080/Images/";
  useEffect(() => {
    const emails = sessionStorage.getItem('email');
    const rolsId = sessionStorage.getItem('rolls');
    setCompanyId(+sessionStorage.getItem('comid'));
    setCompanyId(+sessionStorage.getItem('comid'));
    if (emails === "superadmin@gmail.com") {
      setRoleId(1001);
    } else if(rolsId==1012){
      setRoleId(1012);
    }else if(emails === "gh@gmail.com"){
      setRoleId(1012);
    }else {
      setRoleId(2);
    }

  }, []);
  useEffect(() => {
    
   
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/menu/by-roles/6`;
    const menuList = () => axios.get(REST_API_BASE_URL);
    menuList().then((res) => {
      const nested = buildMenuTree(res.data);
      setMenusData(nested);
    }).catch(error => {
      console.error(error);
    })
  }, [])
  return (

    <div>

      <div id="loading-wrapper">
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
        <div className="spin-wrapper">
          <div className="circle" />
          <div className="circle" />
        </div>
      </div>
      <div className="page-wrapper">
        <div className="main-container">
          <nav id="sidebar" className="sidebar-wrapper">
            <div className="brand-container d-flex align-items-center justify-content-between">
              <div className="app-brand ms-3">
                <a href={"/dashboard"} action>
                  <img src="assets/images/logo.jpg" className="logo" alt="Dental Care Admin Template" />
                </a>
              </div>
              <button type="button" className="pin-sidebar me-3">
                <i className="ri-menu-line" />
              </button>
            </div>
            {roleId === 2 ? (<div className="sidebar-profile">
              <img src="assets/images/doctor5.png" className="rounded-5 border border-primary border-3" alt="Dentist Admin Templates" />
              <h6 className="mb-1 profile-name text-nowrap text-truncate text-primary">Jennifer Arter</h6>
              <small className="profile-name text-nowrap text-truncate">Department Head</small>

            </div>) : (<></>)}

            <div className="sidebarMenuScroll" style={{ paddingBottom: "10px" }}>
              {/*For dynamically menus coming */}
              {roleId === 1001 ? (
        <ul className="sidebar-menu">
          <li className="active current-page">
            <a href="/dashboard-sadmin">
              <i className="ri-home-6-line" />
              <span className="menu-text">Dashboard</span>
            </a>
          </li>
          <li className="treeview">
            <a href="#!">
              <i className="ri-building-2-line" />
              <span className="menu-text">Comapny</span>
            </a>
            <ul className="treeview-menu">
              <li>
                <a href="/create-company">Create Company</a>
              </li>
              <li>
                <a href="/view-company">View Company</a>
              </li>
              <li>
                <a href="/company-settings">Settings</a>
              </li>
              <li>
                <a href="/notifications">Notifications</a>
              </li>
              <li>
                <a href="/company-type">Company Type</a>
              </li>
              <li>
                <a href="/create-roles">Create Roles</a>
              </li>
            </ul>
          </li>
          <li className="treeview">
                          
                          <a href="#!">
                            <i className="ri-menu-2-line" />
                            <span className="menu-text">Modules</span>
                          </a>
                          <ul class="treeview-menu">
                  <li>
                    <a href={"/create-modules"}>Create Modules</a>
                  </li>
                  <li>
                    <a href={"/create-modules-menu"}>Create Modules Menus</a>
                  </li>
                  <li>
                    <a href={"/create-sub-menu"}>Create Sub Menus</a>
                  </li>
                </ul>
                        </li>
        </ul>
      ) : (roleId===1012?(
        {/* <ul className="sidebar-menu">
                        <li className="active current-page">
                          <a href={"/dashboard-company"}>
                            <i className="ri-home-6-line" />
                            <span className="menu-text">Dashboard</span>
                          </a>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-building-2-line" />
                            <span className="menu-text">Users</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/admin-add"}>Add Users</a>
                            </li>
                            <li>
                              <a href={"/admin-view"}>View Users</a>
                            </li>
                            <li>
                              <a href={"/admin-update"}>Update Users</a>
                            </li>
                            <li>
                              <a href={"/userAdd-departments"}>Add Departments</a>
                            </li>
                            {/* <li>
                              <a href={"/edit-departments"}>Edit Departments</a>
                            </li> */},
                            {/* <li>
                              <a href={"/departments-list"}>Departments List</a>
                            </li> */},
                            {/*<li>
                              <a href={"/add-designations"}>Add Designtions</a>
                            </li>
                            <li>
                              <a href={"/users-type"}>Users Type</a>
                            </li>*/},
                            {/* <li>
                              <a href={"/create-company"}>Create Company</a>
                            </li>
                            <li>
                              <a href={"/view-company"}>View Company</a>
                            </li> */},
                         {/* </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-stethoscope-line" />
                            <span className="menu-text">Doctors</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/doctor-dashboard"}>Doctors Dashboard</a>
                            </li>
                            <li>
                              <a href={"/add-doctors"}>Add Doctors</a>
                            </li>
                            <li>
                              <a href={"/view-doctors"}>View Doctors</a>
                            </li>
                            
                            
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-empathize-line" />
                            <span className="menu-text">Patients</span>
                          </a>
                          <ul className="treeview-menu">
                          
                          <li>
                              <a href={"/patients-profile"}>Patients Dashboard</a>
                            </li>
                            <li>
                              <a href={"/add-patients"}>Add Patients</a>
                            </li>
                            <li>
                              <a href={"/patients-lists"}>View Patients</a>
                            </li>
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-empathize-line" />
                            <span className="menu-text">Appointments</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/appointment-list"}>Appointment List</a>
                            </li>
                            <li>
                              <a href={"/appointments"}>Appointments</a>
                            </li>
                            <li>
                              <a href={"/book-appointment"}>Book Appointment</a>
                            </li>
                            <li>
                              <a href={"/edit-appointment"}>Edit Appointments</a>
                            </li>
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-car-washing-line" />
                            <span className="menu-text">Ambulance</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/ambulance-list"}>Ambulance List</a>
                            </li>
                            <li>
                              <a href={"/add-ambulance"}>Add Ambulance</a>
                            </li>
                            <li>
                              <a href={"/edit-ambulance"}>Edit Ambulance</a>
                            </li>
                            <li>
                              <a href={"/call-list"}>Ambulance Call List</a>
                            </li>
                            <li>
                              <a href={"/add-driver"}>Add Driver</a>
                            </li>
                            <li>
                              <a href={"/edit-driver"}>Edit Driver</a>
                            </li>
                            <li>
                              <a href={"/driver-list"}>Driver List</a>
                            </li>
                            
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-hotel-bed-line" />
                            <span className="menu-text">Rooms</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/statistics"}>Statistics</a>
                            </li>
                            <li>
                              <a href={"/rooms-allotted"}>Rooms Allotted</a>
                            </li>
                            <li>
                              <a href={"/rooms-by-department"}>Rooms By Department</a>
                            </li>
                            <li>
                              <a href={"/available-rooms"}>Available Rooms</a>
                            </li>
                            <li>
                              <a href={"/book-rooms"}>Book Rooms</a>
                            </li>
                            <li>
                              <a href={"/add-rooms"}>Add Rooms</a>
                            </li>
                            <li>
                              <a href={"/all-rooms"}>All Rooms</a>
                            </li>
                           
                            
                          </ul>
                        </li>                      
                        <li className="treeview">
                          
                          <a href="#!">
                            <i className="ri-settings-5-line" />
                            <span className="menu-text">Settings</span>
                          </a>
                          <ul class="treeview-menu">
                  <li>
                    <a href={"/user-settings"}>User Settings</a>
                  </li>
                  <li>
                    <a href={"/create-company"}>Create Company</a>
                  </li>
                </ul>
                        </li>
                        <li>
                          <a href={"/login"} action onClick={handleLogout}>
                            <i className="ri-login-circle-line" />
                            <span className="menu-text">Logout</span>
                          </a>
                        </li>
                      </ul> */},
                      <SidebarmenuC companyIds={companyId}/>
      ):(
        <SidebarMenu menus={menusData} />
      ))}
              
              {/* <ul className="sidebar-menu">
                        <li className="active current-page">
                          <a href={"/dashboard"}>
                            <i className="ri-home-6-line" />
                            <span className="menu-text">Dashboard</span>
                          </a>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-building-2-line" />
                            <span className="menu-text">Users</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/enter-users"}>Add Users</a>
                            </li>
                            <li>
                              <a href={"/view-users"}>View Users</a>
                            </li>
                            <li>
                              <a href={"/add-departments"}>Add Departments</a>
                            </li>
                            <li>
                              <a href={"/edit-departments"}>Edit Departments</a>
                            </li>
                            <li>
                              <a href={"/departments-list"}>Departments List</a>
                            </li>
                            <li>
                              <a href={"/add-designations"}>Add Designtions</a>
                            </li>
                            <li>
                              <a href={"/create-company"}>Create Company</a>
                            </li>
                            <li>
                              <a href={"/view-company"}>View Company</a>
                            </li>
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-stethoscope-line" />
                            <span className="menu-text">Doctors</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/doctor-dashboard"}>Doctors Dashboard</a>
                            </li>
                            <li>
                              <a href={"/add-doctors"}>Add Doctors</a>
                            </li>
                            <li>
                              <a href={"/view-doctors"}>View Doctors</a>
                            </li>
                            
                            
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-empathize-line" />
                            <span className="menu-text">Patients</span>
                          </a>
                          <ul className="treeview-menu">
                          
                          <li>
                              <a href={"/patients-profile"}>Patients Dashboard</a>
                            </li>
                            <li>
                              <a href={"/add-patients"}>Add Patients</a>
                            </li>
                            <li>
                              <a href={"/patients-lists"}>View Patients</a>
                            </li>
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-empathize-line" />
                            <span className="menu-text">Appointments</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/appointment-list"}>Appointment List</a>
                            </li>
                            <li>
                              <a href={"/appointments"}>Appointments</a>
                            </li>
                            <li>
                              <a href={"/book-appointment"}>Book Appointment</a>
                            </li>
                            <li>
                              <a href={"/edit-appointment"}>Edit Appointments</a>
                            </li>
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-car-washing-line" />
                            <span className="menu-text">Ambulance</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/ambulance-list"}>Ambulance List</a>
                            </li>
                            <li>
                              <a href={"/add-ambulance"}>Add Ambulance</a>
                            </li>
                            <li>
                              <a href={"/edit-ambulance"}>Edit Ambulance</a>
                            </li>
                            <li>
                              <a href={"/call-list"}>Ambulance Call List</a>
                            </li>
                            <li>
                              <a href={"/add-driver"}>Add Driver</a>
                            </li>
                            <li>
                              <a href={"/edit-driver"}>Edit Driver</a>
                            </li>
                            <li>
                              <a href={"/driver-list"}>Driver List</a>
                            </li>
                            
                          </ul>
                        </li>
                        <li className="treeview">
                          <a href="#!">
                            <i className="ri-hotel-bed-line" />
                            <span className="menu-text">Rooms</span>
                          </a>
                          <ul className="treeview-menu">
                            <li>
                              <a href={"/statistics"}>Statistics</a>
                            </li>
                            <li>
                              <a href={"/rooms-allotted"}>Rooms Allotted</a>
                            </li>
                            <li>
                              <a href={"/rooms-by-department"}>Rooms By Department</a>
                            </li>
                            <li>
                              <a href={"/available-rooms"}>Available Rooms</a>
                            </li>
                            <li>
                              <a href={"/book-rooms"}>Book Rooms</a>
                            </li>
                            <li>
                              <a href={"/add-rooms"}>Add Rooms</a>
                            </li>
                            <li>
                              <a href={"/all-rooms"}>All Rooms</a>
                            </li>
                           
                            
                          </ul>
                        </li>                      
                        <li className="treeview">
                          
                          <a href="#!">
                            <i className="ri-settings-5-line" />
                            <span className="menu-text">Settings</span>
                          </a>
                          <ul class="treeview-menu">
                  <li>
                    <a href={"/user-settings"}>User Settings</a>
                  </li>
                  <li>
                    <a href={"/create-company"}>Create Company</a>
                  </li>
                </ul>
                        </li>
                        <li>
                          <a href={"/login"} action onClick={handleLogout}>
                            <i className="ri-login-circle-line" />
                            <span className="menu-text">Logout</span>
                          </a>
                        </li>
                      </ul> */}
            </div>
            {/* style={{position: "fixed", bottom: 0,}} */}
            <div className="sidebar-contact" >
              <p className="fw-light mb-1 text-nowrap text-truncate">Emergency Contact</p>
              <h5 className="m-0 lh-1 text-nowrap text-truncate">7488141166</h5>
              <i className="ri-phone-line" />
            </div>
          </nav>
          <div className="app-container">
            <div className="app-header d-flex align-items-center">
              <div className="brand-container-sm d-xl-none d-flex align-items-center">
                <div className="app-brand">
                  <a href="#!">
                    <img src="assets/images/logo.jpg" className="logo" alt="Not One" />
                  </a>
                </div>
                <button type="button" className="toggle-sidebar">
                  <i className="ri-menu-line" />
                </button>
              </div>
              <div className="search-container d-xl-block d-none">
                <input type="text" className="form-control" id="searchId" placeholder="Search" />
                <i className="ri-search-line" />
              </div>
              <div className="header-actions">
                <div className="d-lg-flex d-none gap-2">
                  <div className="dropdown">
                    <a className="dropdown-toggle header-icon" href="#!" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src="assets/images/flags/1x1/fr.svg" className="header-country-flag" alt="Bootstrap Dashboards" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-mini">
                      <div className="country-container">
                        <a href="#!" className="py-2">
                          <img src="assets/images/flags/1x1/us.svg" alt="Admin Panel" />
                        </a>
                        <a href="#!" className="py-2">
                          <img src="assets/images/flags/1x1/in.svg" alt="Admin Panels" />
                        </a>
                        <a href="#!" className="py-2">
                          <img src="assets/images/flags/1x1/br.svg" alt="Admin Dashboards" />
                        </a>
                        <a href="#!" className="py-2">
                          <img src="assets/images/flags/1x1/tr.svg" alt="Admin Templatess" />
                        </a>
                        <a href="#!" className="py-2">
                          <img src="assets/images/flags/1x1/gb.svg" alt="Google Admin" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown">
                    <a className="dropdown-toggle header-icon" href="#!" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="ri-star-line" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-300">
                      <h5 className="fw-semibold px-3 py-2 text-primary">Bookmarks</h5>
                      <div className="d-flex justify-content-center gap-3">
                        <a href="doctors-cards.html" className="text-center">
                          <div className="icon-box lg bg-primary-subtle rounded-5 mb-1">
                            <i className="ri-stethoscope-line text-primary fs-4" />
                          </div>
                          Doctors
                        </a>
                        <a href="#!" className="text-center">
                          <div className="icon-box lg bg-primary-subtle rounded-5 mb-1">
                            <i className="ri-nurse-line text-primary fs-4" />
                          </div>
                          Staff
                        </a>
                        <a href="#!" className="text-center">
                          <div className="icon-box lg bg-primary-subtle rounded-5 mb-1">
                            <i className="ri-group-2-line text-primary fs-4" />
                          </div>
                          Patients
                        </a>
                      </div>
                      <div className="d-grid m-3">
                        <a href="javascript:void(0)" className="btn btn-outline-primary">Add New Bookmark</a>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown">
                    <a className="dropdown-toggle header-icon" href="#!" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="ri-list-check-3" />
                      <span className="count-label warning" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-300">
                      <h5 className="fw-semibold px-3 py-2 text-primary">Activity</h5>
                      <div className="scroll300">
                        <div className="p-3">
                          <ul className="p-0 activity-list2">
                            <li className="activity-item pb-3 mb-3">
                              <a href="#!">
                                <h5 className="fw-regular">
                                  <i className="ri-circle-fill text-danger me-1" />
                                  Invoices.
                                </h5>
                                <div className="ps-3 ms-2 border-start">
                                  <div className="d-flex align-items-center mb-2">
                                    <div className="flex-shrink-0">
                                      <img src="assets/images/products/1.jpg" className="img-3x rounded-1" alt="Dentist Admin Templates" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      23 invoices have been paid to the Clove Labs.
                                    </div>
                                  </div>
                                  <p className="m-0 small">10:20AM Today</p>
                                </div>
                              </a>
                            </li>
                            <li className="activity-item pb-3 mb-3">
                              <a href="#!">
                                <h5 className="fw-regular">
                                  <i className="ri-circle-fill text-info me-1" />
                                  Purchased.
                                </h5>
                                <div className="ps-3 ms-2 border-start">
                                  <div className="d-flex align-items-center mb-2">
                                    <div className="flex-shrink-0">
                                      <img src="assets/images/products/2.jpg" className="img-3x rounded-1" alt="Dentist Admin Templates" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      28 new surgical equipments have been purchased.
                                    </div>
                                  </div>
                                  <p className="m-0 small">04:30PM Today</p>
                                </div>
                              </a>
                            </li>
                            <li className="activity-item pb-3 mb-3">
                              <a href="#!">
                                <h5 className="fw-regular">
                                  <i className="ri-circle-fill text-success me-1" />
                                  Appointed.
                                </h5>
                                <div className="ps-3 ms-2 border-start">
                                  <div className="d-flex align-items-center mb-2">
                                    <div className="flex-shrink-0">
                                      <img src="assets/images/products/8.jpg" className="img-3x rounded-1" alt="Dentist Admin Templates" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      36 new doctors and 28 staff members appointed.
                                    </div>
                                  </div>
                                  <p className="m-0 small">06:50PM Today</p>
                                </div>
                              </a>
                            </li>
                            <li className="activity-item">
                              <a href="#!">
                                <h5 className="fw-regular">
                                  <i className="ri-circle-fill text-warning me-1" />
                                  Requested
                                </h5>
                                <div className="ps-3 ms-2 border-start">
                                  <div className="d-flex align-items-center mb-2">
                                    <div className="flex-shrink-0">
                                      <img src="assets/images/products/9.jpg" className="img-3x rounded-1" alt="Dentist Admin Templates" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      Requested for 6 new vehicles for medical emergency. .
                                    </div>
                                  </div>
                                  <p className="m-0 small">08:30PM Today</p>
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="d-grid m-3">
                        <a href="javascript:void(0)" className="btn btn-primary">View all</a>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown">
                    <a className="dropdown-toggle header-icon" href="#!" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="ri-alarm-warning-line" />
                      <span className="count-label success" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-300">
                      <h5 className="fw-semibold px-3 py-2 text-primary">Alerts</h5>
                      <div className="scroll300">
                        <div className="p-3">
                          <div className="d-flex py-2">
                            <div className="icon-box md bg-primary rounded-circle me-3">
                              <span>BS</span>
                            </div>
                            <div className="m-0">
                              <h6 className="mb-1 fw-semibold">Becky Shah</h6>
                              <p className="mb-1">
                                Appointed as a new President 2025
                              </p>
                              <p className="small m-0 opacity-50">Today, 07:30pm</p>
                            </div>
                          </div>
                          <div className="d-flex py-2">
                            <div className="icon-box md bg-primary rounded-circle me-3">
                              <span>UF</span>
                            </div>
                            <div className="m-0">
                              <h6 className="mb-1 fw-semibold">Ursula Frazier</h6>
                              <p className="mb-1">
                                Congratulate, James for new job.
                              </p>
                              <p className="small m-0 opacity-50">Today, 08:00pm</p>
                            </div>
                          </div>
                          <div className="d-flex py-2">
                            <div className="icon-box md bg-primary rounded-circle me-3">
                              <span>MK</span>
                            </div>
                            <div className="m-0">
                              <h6 className="mb-1 fw-semibold">Myra Kane</h6>
                              <p className="mb-1">
                                Lewis added new doctors training schedule.
                              </p>
                              <p className="small m-0 opacity-50">Today, 09:30pm</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-grid m-3">
                        <a href="javascript:void(0)" className="btn btn-primary">View all</a>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown">
                    <a className="dropdown-toggle header-icon" href="#!" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="ri-message-3-line" />
                      <span className="count-label" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-300">
                      <h5 className="fw-semibold px-3 py-2 text-primary">Messages</h5>
                      <div className="scroll300">
                        <div className="p-3">
                          <div className="d-flex py-2">
                            <img src="assets/images/doctor3.png" className="img-3x me-3 rounded-5" alt="Dentist Admin Templates" />
                            <div className="m-0">
                              <h6 className="mb-1 fw-semibold">Albert Winters</h6>
                              <p className="mb-1">
                                Appointed as a new President 2025
                              </p>
                              <p className="small m-0 opacity-50">Today, 07:30pm</p>
                            </div>
                          </div>
                          <div className="d-flex py-2">
                            <img src="assets/images/doctor1.png" className="img-3x me-3 rounded-5" alt="Dentist Admin Templates" />
                            <div className="m-0">
                              <h6 className="mb-1 fw-semibold">Van Robinson</h6>
                              <p className="mb-1">
                                Congratulate, James for new job.
                              </p>
                              <p className="small m-0 opacity-50">Today, 08:00pm</p>
                            </div>
                          </div>
                          <div className="d-flex py-2">
                            <img src="assets/images/doctor4.png" className="img-3x me-3 rounded-5" alt="Dentist Admin Templates" />
                            <div className="m-0">
                              <h6 className="mb-1 fw-semibold">Mara Coffey</h6>
                              <p className="mb-1">
                                Lewis added new doctors training schedule.
                              </p>
                              <p className="small m-0 opacity-50">Today, 09:30pm</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-grid m-3">
                        <a href="javascript:void(0)" className="btn btn-primary">View all</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dropdown ms-3">
                  <a id="userSettings" className="dropdown-toggle d-flex align-items-center" href="#!" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <div className="avatar-box">
                      <img src="assets/images/doctor5.png" className="img-2xx rounded-5 border border-3 border-white" alt="Dentist Dashboard" />
                      <span className="status busy" />
                    </div>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end dropdown-300 shadow-lg">
                    <div className="d-flex align-items-center justify-content-between p-3">
                      <div>
                        <span className="small">Doctor</span>
                        <h6 className="m-0">Martin Boyer, MD</h6>
                      </div>
                      <div className="d-flex flex-column text-end">
                        <h5 className="fw-bold lh-1 m-0">$5900</h5>
                        <div className="text-primary small">Weekly Earnings</div>
                      </div>
                    </div>
                    <div className="mx-3 my-2 d-grid">
                      <a href={"/login"} className="btn btn-primary" onClick={handleLogout}>Logout</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Outlet />


            <div className="app-footer">
              <span>© Webnet HMS Admin 2025</span>
            </div>
          </div>
        </div>
      </div>
    </div>


  );


}
